export const DEVICE_STATES = [
  "사용중",
  "24시간사용",
  "12시간사용",
  "주말사용",
  "공휴일사용",
  "오프라인"
];

export function statusHours(device) {
  const value = device?.status_time;
  if (!["number", "string"].includes(typeof value)) return null;
  if (typeof value === "string" && !value.trim()) return null;
  const hours = Number(value);
  return Number.isFinite(hours) && hours >= 0 ? hours : null;
}

export function koreanDate(now = new Date()) {
  const parts = new Intl.DateTimeFormat("en-CA", {
    timeZone: "Asia/Seoul",
    year: "numeric",
    month: "2-digit",
    day: "2-digit"
  }).formatToParts(now);
  const value = (type) => parts.find((part) => part.type === type).value;
  return `${value("year")}-${value("month")}-${value("day")}`;
}

// null means the available response cannot establish one of the six states.
export function classifyDevice(device, { date, holidays, ready }) {
  const status = String(device?.status || "").toUpperCase();
  if (status === "DISABLE") return "오프라인";
  if (status !== "ACTIVE" || !ready) return null;
  if (holidays.has(date)) return "공휴일사용";
  const weekday = new Date(`${date}T00:00:00Z`).getUTCDay();
  if (weekday === 0 || weekday === 6) return "주말사용";
  const hours = statusHours(device);
  if (hours === null) return null;
  return hours >= 24 ? "24시간사용" : hours >= 12 ? "12시간사용" : "사용중";
}

export function statusDuration(device) {
  const hours = statusHours(device);
  const status = String(device?.status || "").toUpperCase();
  if (hours === null || !["ACTIVE", "DISABLE"].includes(status))
    return "확인 불가";
  const prefix = status === "ACTIVE" ? "활성화" : "비활성화";
  return `${prefix} ${hours < 1 ? "1시간 미만" : `${Math.floor(hours)}시간`}`;
}
